import React from "react";
import { Pages } from "@instructure/ui-pages";
import { Button } from "@instructure/ui-buttons";
import { IconArrowStartLine } from "@instructure/ui-icons";

class DTIPages extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activePageIndex: 0,
    };
  }

  handlePagesBackButtonClick = (activePageIndex) => {
    this.setState({
      activePageIndex,
    });
  };

  handleViewDetailsClick = () => {
    this.setState({
      activePageIndex: 1,
    });
  };

  renderOverviewBar(navigateToPreviousPage, showBack) {
    return (
      <div className="dti-pages-bar">
        {showBack && this.renderBackButton(navigateToPreviousPage)}
        <Button
          onClick={this.handleViewDetailsClick}
          color="secondary"
          size="small"
        >
          Xem danh sách chi tiết →
        </Button>
      </div>
    );
  }

  renderDetailBar(navigateToPreviousPage) {
    return (
      <div className="dti-pages-bar dti-pages-bar--detail">
        <Button
          onClick={navigateToPreviousPage}
          color="secondary"
          size="small"
          renderIcon={IconArrowStartLine}
        >
          Quay lại tổng quan
        </Button>
        <span className="dti-pages-bar__title">Danh sách chi tiết</span>
      </div>
    );
  }

  renderBackButton(navigateToPreviousPage) {
    return (
      <Button
        onClick={navigateToPreviousPage}
        renderIcon={IconArrowStartLine}
        screenReaderLabel="Quay lại"
        withBorder={false}
        withBackground={false}
        size="small"
      />
    );
  }

  render() {
    const { firstPage, secondPage } = this.props;
    return (
      <div className="dti-pages">
        <Pages
          margin="none"
          activePageIndex={this.state.activePageIndex}
          onPageIndexChange={this.handlePagesBackButtonClick}
        >
          <Pages.Page padding="none">
            {(history, navigateToPreviousPage) => (
              <div className="dti-pages-page">
                {this.renderOverviewBar(
                  navigateToPreviousPage,
                  history.length > 1,
                )}
                <div className="dti-pages-body">{firstPage}</div>
              </div>
            )}
          </Pages.Page>
          <Pages.Page padding="none">
            {(history, navigateToPreviousPage) => (
              <div className="dti-pages-page dti-pages-page--detail">
                {this.renderDetailBar(navigateToPreviousPage)}
                <div className="dti-pages-body dti-pages-body--detail">
                  <div className="dti-detail-view">{secondPage}</div>
                </div>
              </div>
            )}
          </Pages.Page>
        </Pages>
      </div>
    );
  }
}

export default DTIPages;
